import { motion } from "framer-motion";
import { Home, MoveHorizontal, Sparkles } from "lucide-react";
import SceneShell from "../components/SceneShell";

/**
 * Scene 63 — Three eternal truths · the business anchor.
 */

const truths = [
  {
    icon: Home,
    head: "Houses",
    tail: "will always sell.",
    accent: "#96C11F",
  },
  {
    icon: MoveHorizontal,
    head: "People",
    tail: "will always move.",
    accent: "#00deb6",
  },
  {
    icon: Sparkles,
    head: "And they will always need",
    tail: "to present those homes in the best possible way.",
    accent: "#e9a820",
  },
];

export default function Scene63_HousesAlwaysSell() {
  return (
    <SceneShell variant="forest" align="left" data-testid="scene-houses-always-sell">
      <div className="relative max-w-[1500px] mx-auto w-full">
        <div className="space-y-6 max-w-5xl">
          {truths.map((t, i) => {
            const Icon = t.icon;
            return (
              <motion.div
                key={t.head}
                initial={{ opacity: 0, x: -24, filter: "blur(8px)" }}
                animate={{ opacity: 1, x: 0, filter: "blur(0px)" }}
                transition={{
                  delay: 1.0 + i * 0.6,
                  duration: 1.0,
                  ease: [0.16, 1, 0.3, 1],
                }}
                className="flex items-start gap-5"
                data-testid={`truth-${i}`}
              >
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0"
                  style={{
                    background: `${t.accent}22`,
                    border: `1px solid ${t.accent}55`,
                  }}
                >
                  <Icon className="w-5 h-5" style={{ color: t.accent }} />
                </div>
                <div className="kn-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1]">
                  <span style={{ color: t.accent, fontWeight: 800 }}>{t.head}</span>{" "}
                  <span style={{ color: "rgba(255,255,255,0.85)" }}>{t.tail}</span>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </SceneShell>
  );
}
